import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  min-height: 0;

  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    font-weight: bold;
  }
`;

export const CreateAndFilter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;

  .divInput {
    display: flex;
    align-items: center;
    border: 1px solid #c4ccd8;
    border-radius: 8px;
    width: 100%;
    padding: 5px 10px;
    gap: 10px;
    color: #8f8f8f;
  }

  input {
    appearance: none;
    font-family: "Poppins";
    font-size: 12px;
    width: 100%;
    border: none;
    color: #544f77;
  }
`;

export const ContactsList = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #c4ccd8;
  border-radius: 8px;
  height: 29rem;
  padding: 10px;
  overflow-y: auto;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const Contact = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  gap: 10px;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }

  .name {
    font-weight: bold;
  }

  .phone {
    color: #2624cd;
  }
`;

export const CreateContactDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  min-height: 0;

  .fields {
    display: flex;
    flex-direction: column;
  }

  .avatarField {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 1rem;
    position: relative;
  }

  .avatarAction {
    position: relative;
  }

  .avatarPreview {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70px;
    width: 70px;
    cursor: pointer;
    position: relative;
  }

  .avatarPreview img {
    height: 64px;
    width: 64px;
    border-radius: 50%;
    object-fit: cover;
  }

  .avatarRemove {
    align-items: center;
    background: rgba(0, 0, 0, 0.55);
    border-radius: 50%;
    color: #ffffff;
    display: flex;
    font-size: 24px;
    height: 64px;
    justify-content: center;
    left: 3px;
    opacity: 0;
    position: absolute;
    top: 3px;
    transition: opacity 0.15s ease;
    width: 64px;
  }

  .avatarPreview:hover .avatarRemove {
    opacity: 1;
  }

  .avatarLabel {
    color: #999;
    font-family: "Poppins";
    font-size: 14px;
    font-weight: 400;
  }

  .avatarOptions {
    background: #ffffff;
    border: 1px solid #e1e6ee;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    min-width: 180px;
    padding: 6px 0;
    position: absolute;
    left: 75px;
    top: 0px;
    z-index: 10;
  }

  .avatarOption {
    align-items: center;
    background: transparent;
    border: none;
    color: #333333;
    cursor: pointer;
    display: flex;
    font-family: "Poppins";
    font-size: 14px;
    gap: 10px;
    padding: 9px 12px;
    text-align: left;
    width: 100%;
  }

  .avatarOption:hover {
    background: #f5f5f5;
  }

  .avatarOption:disabled {
    cursor: default;
    opacity: 0.7;
  }

  .avatarOption img {
    height: 20px;
    width: 20px;
  }

  .avatarOption .pi {
    color: #9b9b9b;
    font-size: 20px;
  }

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    margin-top: auto;
    padding-top: 24px;
    flex-shrink: 0;
  }
`;
